import {
  BUTTON_GO_BACK,
  BUTTON_SAVE,
  MODAL_PRODUCT_TAGS_TITLE_META,
  MODAL_PRODUCT_TAGS_DESCRIPTION_META,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import ModalBasicLayout from "../../../../Modal/ModalBasicLayout";
import { FormProvider, useForm } from "react-hook-form";
import DialogActions from "@mui/material/DialogActions";
import ContainerModalActions from "../../../../Containers/ContainerModalActions";
import ProductTagsForm from "./ProductTagsForm";

const ModalProductTags = ({
  modalOpen,
  onCloseModal = () => {},
  onCallbackSave = () => {},
  initialValue,
}) => {
  const methods = useForm({
    defaultValues: {
      value: initialValue ?? false,
    },
  });
  const { t } = useTranslationApp();

  const onSubmit = async () => {
    const isValid = await methods?.trigger();

    if (!isValid) return;

    const data = methods.getValues();
    onCallbackSave(data.value);
    onCloseModal();
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      maxWidth="xs"
      scroll="paper"
      title={t(MODAL_PRODUCT_TAGS_TITLE_META)}
      description={t(MODAL_PRODUCT_TAGS_DESCRIPTION_META)}
    >
      <FormProvider {...methods}>
        <ProductTagsForm />
      </FormProvider>
      <DialogActions
        sx={{
          p: 0,
        }}
      >
        <ContainerModalActions
          propsSecondaryButton={{
            showButton: true,
            text: BUTTON_GO_BACK,
            onClick: onCloseModal,
          }}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_SAVE,
            onClick: onSubmit,
          }}
        />
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default ModalProductTags;
